// 12-Month Enrollment (E12) Step 2 (Configure Parameters). Display and validation only: the
// reporting scope is the only input, and every E12-specific rule is fixed by the survey, so
// the rest of the step is read-only text describing what the extract will do.
import { getReportingScopeErrors } from './reportingScope';

// Both formats are equally valid for DCS, so neither is preselected.
export const E12_INITIAL_PARAMETERS = {
    reportingYear: '',
    outputFormat: '',
    reportingPeriodStart: null,
    reportingPeriodEnd: null
};

export const E12_RANGE_START_LABEL = 'ipedsWizard.reportingYearRangeStart';
export const E12_RANGE_END_LABEL = 'ipedsWizard.reportingYearRangeEnd';

/** Field → { key, field } for every rule the parameters break. */
export const getE12ParameterErrors = (parameters) => getReportingScopeErrors(parameters, {
    startLabel: E12_RANGE_START_LABEL,
    endLabel: E12_RANGE_END_LABEL,
    endBeforeStartKey: 'ipedsWizard.reportingYearRangeEndBeforeStart'
});
